import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from 'reportWebVitals'

import { Store } from 'Application/Store/Store'
import { Provider } from 'react-redux'
import { ProjectContextProvider } from 'Application/Context/ProjectContext'

import App from 'Ui/App'
import 'Application/Templates/Css/App.css'
import 'Application/Templates/Css/MediaQueries.css'
import 'Application/Templates/Css/Index.css'
import 'Application/Templates/Css/Components/Dropdown.css'
import 'Application/Templates/Css/Assets/Logo.css'

/*******************************************************************************************************
  .--,-``-.
 /   /     '.      ,---,                           ,---,    ,---,.           .---.    ,---,.,-.----.
/ ../        ;   .'  .' `\                 ,---.,`--.' |  ,'  .' |          /. ./|  ,'  .' |\    /  \
\ ``\  .`-    ',---.'     \               /__./||   :  :,---.'   |      .--'.  ' ;,---.'   |;   :    \
 \___\/   \   :|   |  .`\  |         ,---.;  ; |:   |  '|   |   .'     /__./ \ : ||   |   .'|   | .\ :
      \   :   |:   : |  '  |        /___/ \  | ||   :  |:   :  |-, .--'.  '   \' .:   :  |-,.   : |: |
      /  /   / |   ' '  ;  :        \   ;  \ ' |'   '  ;:   |  ;/|/___/ \ |    ' ':   |  ;/||   |  \ :
      \  \   \ '   | ;  .  |         \   \  \: ||   |  ||   :   .';   \  \;      :|   :   .'|   : .  /
  ___ /   :   ||   | :  |  '          ;   \  ' .'   :  ;|   |  |-, \   ;  `      ||   |  |-,;   | |  \
 /   /\   /   :'   : | /  ;            \   \   '|   |  ''   :  ;/|  .   \    .\  ;'   :  ;/||   | ;\  \
/ ,,/  ',-    .|   | '` ,/              \   `  ;'   :  ||   |    \   \   \   ' \ ||   |    \:   ' | \.'
\ ''\        ; ;   :  .'                 :   \ |;   |.' |   :   .'    :   '  |--" |   :   .':   : :-'
 \   \     .'  |   ,.'                    '---" '---'   |   | ,'       \   \ ;    |   | ,'  |   |.'
  `--`-,,-'    '---'                                    `----'          '---"     `----'    `---'
*********************************************************************************************************/

ReactDOM.render(
  <React.StrictMode>
    <Provider store={Store}>
      <ProjectContextProvider>
        <App />
      </ProjectContextProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register(process.env.PUBLIC_URL + '/service-worker.js');
}
